/** @format */

import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { AxiosContext } from "../context/AxiosContext";

/**
 * Searchable Semantic UI dropdown of distinct `battery_id` values from
 * `public."battery-data"` (recent months). Data is server-cached ~10 minutes.
 *
 * Props mirror {@link BatteryIdsDropdownSearch}: selectedBatteryId,
 * setSelectedBatteryId, placeholder, fluid; plus optional `months` (1–36).
 */
export function BatteryDataIdsDropdown({
  selectedBatteryId,
  setSelectedBatteryId,
  placeholder = "Battery ID",
  fluid = true,
  disabled = false,
  months = 3,
  style,
  className,
}) {
  const [options, setOptions] = useState(undefined);
  const { axiosInstance } = useContext(AxiosContext);

  useEffect(() => {
    if (!axiosInstance) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axiosInstance.get(
          "/batteries/data/distinct_battery_ids",
          { params: { months } }
        );
        if (cancelled) return;
        setOptions(Array.isArray(data?.data) ? data.data : []);
      } catch (_) {
        if (!cancelled) setOptions([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [axiosInstance, months]);

  return (
    <Dropdown
      className={className}
      style={style}
      selectOnBlur={false}
      placeholder={placeholder}
      search
      selection
      fluid={fluid}
      options={options}
      value={selectedBatteryId}
      clearable
      loading={options === undefined}
      disabled={disabled}
      onChange={(_, { value }) =>
        setSelectedBatteryId(value != null && value !== "" ? value : null)
      }
    />
  );
}

export default BatteryDataIdsDropdown;
